import { Types } from '@store/types';

const ActivePageReducer = (state = { currentPage: { id: null, type: '', pageType: 'DETAILS' } }, action) => {
	switch (action.type) {
		case Types.SET_CURRENT_ACTIVE_PAGE:
			return { ...state, currentPage: action.payload };
		case Types.CLEAR_CURRENT_ACTIVE_PAGE:
			return { ...state, currentPage: action.payload };
		default:
			return state;
	}
};

export default ActivePageReducer;
